import { render } from "./LoadingSpinner.vue?vue&type=template&id=23b874ed&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=23b874ed&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b874ed"],['__file',"src/components/LoadingSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23b874ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23b874ed', __exports__)) {
    console.log('reload')
    api.reload('23b874ed', __exports__)
  }
  
  module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=23b874ed&scoped=true", () => {
    console.log('re-render')
    api.rerender('23b874ed', render)
  })

}


export default __exports__